/** Country-based first-visit language choice. Shopify still controls selling markets. */
(() => {
  const config = document.querySelector('[data-fm-localization]');
  if (!config || window.Shopify?.designMode) return;

  const preferenceKey = 'fm-language-preference';
  const checkedKey = 'fm-language-detected';
  const read = (storage, key) => {
    try { return window[storage].getItem(key); } catch { return null; }
  };
  const write = (storage, key, value) => {
    try { window[storage].setItem(key, value); } catch { /* Storage can be disabled. */ }
  };
  const languages = JSON.parse(config.dataset.languages);

  // Capture changes before the theme's localization component submits its form.
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLSelectElement && event.target.name === 'language_code') {
      write('localStorage', preferenceKey, event.target.value);
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action$="/localization"]')) return;
    const language = new FormData(form).get('language_code');
    if (language) write('localStorage', preferenceKey, String(language));
  }, true);

  // An explicit /en link is a deliberate language choice, including search results.
  if (config.dataset.language !== 'tr') return;

  function choose(language) {
    if (!languages[language] || language === config.dataset.language) return;
    const currentRoot = languages[config.dataset.language].replace(/\/$/, '');
    const nextRoot = languages[language].replace(/\/$/, '');
    const path = window.location.pathname.slice(currentRoot.length);
    window.location.replace(nextRoot + (path || '/') + window.location.search + window.location.hash);
  }

  const preference = read('localStorage', preferenceKey);
  if (preference && languages[preference]) {
    choose(preference);
    return;
  }
  if (read('sessionStorage', checkedKey)) return;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
    signal: controller.signal,
    credentials: 'same-origin',
  })
    .then((response) => response.ok ? response.json() : null)
    .then((data) => {
      const country = data?.detected_values?.country?.handle;
      if (!/^[A-Z]{2}$/.test(country || '')) return;
      write('sessionStorage', checkedKey, '1');
      // Do not override a choice made while the country request was in flight.
      if (!read('localStorage', preferenceKey)) choose(country === 'TR' ? 'tr' : 'en');
    })
    .catch(() => { /* Retain the current language if detection is unavailable. */ })
    .finally(() => clearTimeout(timeout));
})();
